module.exports = __webpack_public_path__ + "static/media/IndustrialWaste.b9fe1a59.svg";